import * as testIds from '@chegg-wt/core/components/UpgradeAdFrame/testIds'
import { ListItemProps } from '@chegg/wt-checkout'
import { UpgradeCopy } from '@chegg-wt/core/types/core'

const upgradeCopy: UpgradeCopy = {
  button: 'Try Easybib® Plus',
  header: "Don't let plagiarism errors spoil your paper",
  body: [
    {
      bullet: 'Scan your paper for plagiarism mistakes',
      dataTestId: testIds.UPGRADE_BULLET_PLAGIARIAM,
    },
    {
      bullet: 'Get help for 7,000+ citation styles including APA 6',
      dataTestId: testIds.UPGRADE_BULLET_STYLES,
    },
    {
      bullet: 'Check for 400+ advanced grammar errors',
      dataTestId: testIds.UPGRADE_BULLET_GRAMMAR,
    },
    {
      bullet: 'Create in-text citations and save them',
      dataTestId: testIds.UPGRADE_BULLET_INTEXT,
    },
    {
      bullet: 'Free 3-day trial. Cancel anytime.*',
      dataTestId: testIds.UPGRADE_BULLET_TRIAL,
      isFreeTrial: true,
    },
  ],
}

// WT-Checkout FeatureList
export const ebFeatureList: ListItemProps[] = [
  {
    text: 'Access to all writing, plagiarism and spelling issues',
  },
  {
    text: 'Check unlimited papers',
  },
  {
    text: 'Save your papers online',
  },
]

export default upgradeCopy
